<template>
    <div class="pay">
      <img src='/images/order/paySuc.png' class='imgs'>
      <div class='tips'>评价成功</div>
      <div class='suclog'>你的评价是我们持续改进的动力</div>
      <div class='btn_content'>
        
        <button class="btn-small-default-round btn"  style='margin-right:20px;' @click="$router.replace({name:'homeIndex'})">返回首页</button>
        <button class="btn-small-default-round btn"  @click="$router.replace({name:'orderList',params: {type: totype}})" >查看订单</button>
        
        <!-- <button class="btn-small-default-round btn"  style='margin-right:20px;' @click="$router.push({name:'rechargeRecord'})" v-if='type == 2'>充值记录</button> -->
        <!-- <button class="btn-small-default-round btn"  @click="$router.push({name:'myIndex'})" v-if='type == 2'>个人中心</button> -->
      </div>
    </div>
</template>

<script>
  export default {
    name: 'index',
    data(){
      return {
        type : 1,
        totype : 1,
      }
    },
    computed:{
    },
    created(){
    },
    methods: {
      
    }
  }
</script>

<style scoped lang="scss">

  .btn_content{
    margin-top: 50px;
    display: flex;
    justify-content:center;
  }
  .imgs{
    width: 40%;
    margin-left:30%; 
    margin-top: 30%;
  }
  .img_chat{
    width: 40%;
    margin-left:30%; 
    margin-top: 40px;
  }
  .tips{
    font-size: 60px;
    text-align: center;
    color:#6DDEDE;
    margin-top: 60px;
  }
  .suclog{
    font-size: 30px;
    color:#999999;
    text-align: center;
    margin-top:50px; 
  }
</style>
